import type { DeployFailureReason } from '@cli-types/next-adapter/vercel.js'

export function deployFailureMessage(reason?: DeployFailureReason): string {
  switch (reason) {
    case 'timeout':
      return 'Vercel deploy timed out.'
    default:
      return 'Vercel deploy did not complete.'
  }
}
